import { render, staticRenderFns } from "./AgentsTab.vue?vue&type=template&id=6063a1b6&scoped=true&"
import script from "./AgentsTab.vue?vue&type=script&lang=js&"
export * from "./AgentsTab.vue?vue&type=script&lang=js&"
import style0 from "./AgentsTab.vue?vue&type=style&index=0&id=6063a1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063a1b6",
  null
  
)

export default component.exports